import { render, staticRenderFns } from "./DeclarationDetail.vue?vue&type=template&id=57278246&scoped=true&"
import script from "./DeclarationDetail.vue?vue&type=script&lang=js&"
export * from "./DeclarationDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationDetail.vue?vue&type=style&index=0&id=57278246&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57278246",
  null
  
)

export default component.exports